import Telemetry from '@atlassian/mpac-telemetry';
export const AppListingTask = Telemetry.createGenericTask('view-app-listing');